var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.ip),function(ipValue,index){return _c('span',{key:index},[_c('CopyToClipboardText',{attrs:{"text":ipValue}}),_vm._v(" "),(index !== _vm.ip.length-1)?_c('span',[_vm._v(", ")]):_vm._e()],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }